import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  variant?: 'success' | 'error' | 'warning' | 'info';
  visible: boolean;
  duration?: number;
  onClose?: () => void;
  fullWidth?: boolean;  // New prop to control width
  position?: 'fixed' | 'relative'; // New prop to control positioning
}

const ToastComponent: React.FC<ToastProps> = ({
  message,
  variant = 'success',
  visible,
  duration = 3000,
  onClose,
  fullWidth = false,
  position = 'fixed'
}) => {
  useEffect(() => {
    if (visible && duration) {
      const timer = setTimeout(() => {
        if (onClose) onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [visible, duration, onClose]);

  if (!visible) return null;

  const variantClasses = {
    success: 'bg-green-500 text-white',
    error: 'bg-red-500 text-white',
    warning: 'bg-yellow-500 text-white',
    info: 'bg-blue-500 text-white'
  };

  // Position class based on position prop
  const positionClass = position === 'fixed' 
    ? 'fixed top-4 right-4 z-50' 
    : 'relative w-full';

  return (
    <div 
      className={`${positionClass} px-4 py-2 rounded-lg shadow-lg ${variantClasses[variant]} transition-opacity duration-300 ${fullWidth ? 'w-full' : ''} text-center`}
      role="alert"
    >
      {message}
    </div>
  );
};

export default ToastComponent;
